import '../../App.scss';

const Bottom = ({ children, style }: any) => (
  <div className="fixed-to-bottom" style={style}>
    {children}
  </div>
);

export default Bottom;
